import { connect } from "react-redux";
import FinanceDirectorAction from "./FinanceDirectorAction";
import { bindActionCreators } from "redux";
import { payoutDetailsWithId, updateAllPayoutDetails, payoutAccountDetails } from "services/redux/CarLoan/action";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    getAllThePayoutDetailsWithId : state.CarLoan.getAllThePayoutDetailsWithId,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    updatePayoutDetailsWithId: state.CarLoan.updatePayoutDetailsWithId,
    getPayoutAccountDetailsWithId: state.CarLoan.getPayoutAccountDetailsWithId
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        payoutDetailsWithId,
        documentUploadUrlPublic,
        updateAllPayoutDetails,
        payoutAccountDetails
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FinanceDirectorAction);